import { render, staticRenderFns } from "./RegExam.vue?vue&type=template&id=7c22ef61&scoped=true&"
import script from "./RegExam.vue?vue&type=script&lang=js&"
export * from "./RegExam.vue?vue&type=script&lang=js&"
import style0 from "./RegExam.vue?vue&type=style&index=0&id=7c22ef61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22ef61",
  null
  
)

export default component.exports